import { Nullable } from "@/general/custom-types/CustomTypes";

export class CustomerFormModel {
  id?: Nullable<number>;
  name?: Nullable<string>;
  street?: Nullable<string>;
  city?: Nullable<string>;
  country?: Nullable<string>;
  active?: Nullable<boolean>;

  constructor(
    id?: Nullable<number>,
    name?: Nullable<string>,
    street?: Nullable<string>,
    city?: Nullable<string>,
    country?: Nullable<string>,
    active: Nullable<boolean> = true
  ) {
    this.id = id;
    this.name = name;
    this.street = street;
    this.city = city;
    this.country = country;
    this.active = active;
  }
}
